import React from "react";
import { DimensionModel } from "./useElementDimensions";

export const PageWrapperDimensionsContext = React.createContext<DimensionModel>(undefined);

export default function useDimensionContext() {
    return React.useContext(PageWrapperDimensionsContext);
}
